import React from 'react';
import classnames from 'classnames';

// Types
import { User } from 'Shared/constants/types';

// Styles
import './UserBgImage.scss';

type Props = {
  size?: 'sm' | 'lg';
  user: User;
};

const UserBgImage = ({ size = 'lg', user }: Props) => {
  const baseClassName = 'UserBgImage';

  const modulo = user?.avatar.initials.toLowerCase().charCodeAt(0) % 3;
  const classes = classnames(baseClassName, `${baseClassName}--${size}`, {
    [`${baseClassName}--gradient-blue`]: modulo === 0,
    [`${baseClassName}--gradient-orange-purple`]: modulo === 1,
    [`${baseClassName}--gradient-pink`]: modulo === 2,
  });

  return <div className={classes} />;
};

export default UserBgImage;
